function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7.316 10.474c0 .214.025.423.057.631H1.632A1.263 1.263 0 01.368 9.842V2.263C.368 1.563.931 1 1.632 1H5.42l1.263 1.263h5.053A1.263 1.263 0 0113 3.526v3.67a3.762 3.762 0 00-1.895-.512 3.792 3.792 0 00-3.79 3.79zm4.42-.632V7.947h-1.262v1.895H8.579v1.263h1.895V13h1.263v-1.895h1.895V9.842h-1.895z",
  fill: "currentColor"
});

var SvgCreate = function SvgCreate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _ref);
};

export default SvgCreate;